module.exports = __webpack_public_path__ + "c3df1f1f2a2df1c72fc8bff757fffcca.png";